import BaseService from './Base';
import ConfigService from './Config';

class WorkOrderTriggerService extends BaseService {
  static endpoint = 'api/2.0/work-orders/';

  static async getWorkOrderHidden(id, params, skipLoading) {
    const filters = {...params , hidden: true};
    const url = ConfigService.generateURL(this.endpoint + id + '/', filters );
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    try {
      const response = await window.fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': 'jwt ' + localStorage.getItem('jwt_token'),
          'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    }
    catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  };

  static async getPlatformFields(params, skipLoading) {
    const url = ConfigService.generateURL(this.endpoint + 'pms-platform-fields/', params );
    if (!skipLoading && ConfigService.contextApi) {
      ConfigService.contextApi.setLoading(true);
    }
    try {
      const response = await window.fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': 'jwt ' + localStorage.getItem('jwt_token'),
          'Time-Zone': jstz.determine().name()
        }
      });
      const JSONresponse = await response.json();
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return JSONresponse;
    }
    catch (e) {
      if (!skipLoading && ConfigService.contextApi) {
        ConfigService.contextApi.setLoading(false);
      }
      return null;
    }
  };
}

export default WorkOrderTriggerService;